<template>
  <v-data-table
    :loading="loading"
    :headers="headersToShow"
    :items="entities"
    :rows-per-page-items="[10, 20, 30, 50, 100]"
    :pagination.sync="paginationModel"
    :total-items="paginationModel.totalItems"
    class="small-data-table"
  >
    <template slot="items" slot-scope="props">
      <template v-for="col of headersToShow">
        <td :class="getTdClass(col, props.item.readed)" :key="`${props.item.id}-${col.value}`">
          <template v-if="col.value == 'controlStatus'">
            <control-status-button v-if="adminView" v-model="props.item"></control-status-button>
          </template>
          <template v-if="col.value == 'actions'">
            <v-btn
              v-if="props.item.documents.length"
              small
              flat
              icon
              class="pa-0 ma-0"
              @click="downloadDocuments(props.item)"
              color="primary"
            >
              <v-icon small>
                mdi-download
              </v-icon>
            </v-btn>
            <v-btn
              small
              flat
              icon
              v-if="!adminView && props.item.status === 'opened'"
              class="pa-0 ma-0"
              @click="editItem(props.item)"
              color="primary"
            >
              <v-icon small>
                edit
              </v-icon>
            </v-btn>
            <v-btn
              class="pa-0 ma-0"
              flat
              small
              icon
              v-if="adminView"
              color="primary"
              @click="editItem(props.item)"
            >
              <v-icon small>
                edit
              </v-icon>
            </v-btn>
            <v-btn
              class="pa-0 ma-0"
              v-if="adminView && props.item.status === 'cancelled'"
              small
              flat
              icon
              color="error"
              @click="deleteItem(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <v-btn
              class="pa-0 ma-0"
              v-if="adminView && props.item.status !== 'cancelled'"
              small
              flat
              icon
              color="error"
              @click="markAsCancelled(props.item)"
            >
              <v-icon color="error">mdi-cancel</v-icon>
            </v-btn>
            <v-btn small flat icon color="grey" class="pa-0 ma-0" @click="showItem(props.item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
            <v-menu v-if="adminView" offset-y>
              <v-btn class="pa-0 ma-0" slot="activator" color="primary" small icon flat>
                <v-icon small>mdi-dots-horizontal</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="markAsFinished(props.item)">
                  <v-list-tile-title>
                    <v-icon color="primary">mdi-check</v-icon>
                    {{ $t('Finalizada') }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="markAsCancelled(props.item)">
                  <v-list-tile-title>
                    <v-icon color="error">mdi-cancel</v-icon>
                    {{ $t('Cancelada') }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="markAsWaiting(props.item)">
                  <v-list-tile-title>
                    <v-icon color="secondary">mdi-progress-clock</v-icon>
                    {{ $t('En proceso') }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="markAsOpened(props.item)">
                  <v-list-tile-title>
                    <v-icon color="grey">mdi-progress-alert</v-icon>
                    {{ $t('Enviada') }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="markAsNotReaded(props.item)">
                  <v-list-tile-title>
                    <v-icon color="grey">mdi-close-circle-outline</v-icon>

                    {{ $t('Marcar como NO leída') }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="markAsReaded(props.item)">
                  <v-list-tile-title>
                    <v-icon color="primary">mdi-check-circle-outline</v-icon>

                    {{ $t('Marcar como leída') }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <template v-else-if="col.value == 'status'">
            <span v-if="props.item.status === 'opened'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="grey">mdi-progress-upload</v-icon>
                </template>
                <span>{{ $t('Enviada') }}</span>
              </v-tooltip>
            </span>
            <span v-if="props.item.status === 'waiting'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="secondary" v-on="on">mdi-clock-outline</v-icon>
                </template>
                <span>{{ $t('En proceso') }}</span>
              </v-tooltip>
            </span>
            <span v-if="props.item.status === 'finished'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="primary">mdi-check</v-icon>
                </template>
                <span>{{ $t('Finalizada') }}</span>
              </v-tooltip>
            </span>
            <span v-if="props.item.status === 'cancelled'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error">mdi-cancel</v-icon>
                </template>
                <span>{{ $t('Cancelada') }}</span>
              </v-tooltip>
            </span>
          </template>
          <template v-else-if="col.value === 'readed'">
            <span v-if="props.item.readed">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="primary">mdi-check-circle-outline</v-icon>
                </template>
                <span>{{ $t('Leída') }}</span>
              </v-tooltip>
            </span>
            <span v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="grey">mdi-close-circle-outline</v-icon>
                </template>
                <span>{{ $t('No leída') }}</span>
              </v-tooltip>
            </span>
          </template>
          <template v-else-if="col.value === 'worker_fullname'">
            <v-tooltip top v-if="!adminView">
              <v-icon
                v-if="props.item['documents'].find(item => !item.pivot['downloaded'])"
                slot="activator"
                color="primary"
              >
                new_releases
              </v-icon>
              <span><b>Nueva documentación disponible para descargar</b></span>
            </v-tooltip>
            {{ props.item[col.value] }}
          </template>
          <template v-else-if="'type'">
            {{ $t(props.item[col.value]) }}
          </template>
          <template v-else>
            {{ props.item[col.value] }}
          </template>
        </td>
      </template>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import ControlStatusButton from '../ControlStatusButton.vue';

export default {
  components: { ControlStatusButton },
  props: {
    entities: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {
          descending: true,
          page: 1,
          rowsPerPage: 10, // -1 for All",                    <v-icon color="primary">mdi-check</v-icon>
        };
      },
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: 'Empr',
          align: 'left',
          value: 'codempre',
        },
        {
          text: 'Trabajador/a',
          align: 'left',
          value: 'worker_fullname',
          sortable: false,
        },
        {
          text: 'Empresa',
          align: 'left',
          value: 'company_name',
          sortable: false,
        },
        { text: 'Tipo', value: 'type' },
        { text: 'F. Solicitud', value: 'date' },
        { text: 'F. Efecto', value: 'effect_date' },
        { text: 'Proceso', value: 'controlStatus', align: 'left' },
        { text: 'Estado', value: 'status' },
        { text: 'Leída', value: 'readed' },

        { text: 'Acciones', value: 'actions', align: 'right', sortable: false },
      ],
    };
  },

  computed: {
    headersToShow() {

      let headers = [...this.headers];

       headers = this.headers.filter(item => {
        if (item.value === 'codempre' && !this.adminView) {
          return false;
        }
        if (item.value === 'company_name' && !this.adminView) {
          return false;
        }
        if (item.value === 'readed' && !this.adminView) {
          return false;
        }
        if (item.value === 'date' && !this.adminView) {
          return false;
        }
        if (item.value === 'controlStatus' && !this.adminView) {
          return false;
        }

        return true;
      });

      if (!this.adminView) {
      const statusColumn = headers.find(item => item.value === 'status');

      if (statusColumn) {
        // Remove 'status' column from headers
        headers = headers.filter(item => item.value !== 'status');
        // Insert 'status' column at the second position
        headers.splice(1, 0, { ...statusColumn });
      }
    }
      return headers;
    },

    paginationModel: {
      get: function() {
        return this.pagination;
      },
      set: function(value) {
        this.$emit('update:pagination', value);
      },
    },
  },

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    getTdClass(col, readed) {
      const readedOrNotClass = this.adminView && !readed ? 'not-readed' : 'readed';

      if (col.value === 'actions') {
        return `${readedOrNotClass} text-xs-right pr-0`;
      }

      return `${readedOrNotClass} text-xs-left`;
    },
    showItem(item) {
      console.log(item);
      this.$emit('show-item-clicked', item);
    },
    editItem(item) {
      console.log(item);
      this.$emit('edit-item-clicked', item);
    },
    downloadDocuments(item) {
      this.$emit('download-documents', item);
    },
    deleteItem(item) {
      console.log(item);
      this.$emit('delete-item-clicked', item);
    },
    markAsFinished(item) {
      this.$emit('finish-item-clicked', item);
    },
    markAsCancelled(item) {
      this.$emit('cancel-item-clicked', item);
    },
    markAsWaiting(item) {
      this.$emit('waiting-item-clicked', item);
    },
    markAsOpened(item) {
      this.$emit('opened-item-clicked', item);
    },
    markAsNotReaded(item) {
      this.$emit('mark-as-not-readed-item-clicked', item);
    },
    markAsReaded(item) {
      this.$emit('mark-as-readed-item-clicked', item);
    },
    initialize() {},
  },
};
</script>

<style>
.not-readed {
  background-color: #ffffe0;
}

.v-chip .v-chip__content {
  height: auto;
}
</style>
